import React from 'react';

import { Box, Divider, Flex, Grid } from '@chakra-ui/react';

import { RadioSelect } from 'uiToolkitV1/RadioSelect/RadioSelect';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const RadioSelectGroup = ({ data, headers, onChange, selectedIndexList }) => (
  <Box
    bgColor="surface.FDFDFD"
    borderColor="neutral.EBEFF3"
    borderWidth="1px"
    borderRadius="4px"
    p="12px 12px 0px 12px"
  >
    <Grid templateColumns="1fr 1fr" p="10px 12px" borderRadius="4px" bgColor="surface.F5F7F9">
      {headers.map((header) => (
        <TextBodyMedium flex={1} color="text.g1" key={header}>
          {header}
        </TextBodyMedium>
      ))}
    </Grid>
    <Box>
      <Grid templateColumns="1fr 1fr" templateRows={`repeat(${data.length}, auto)`}>
        {data.map((radioData, index) => {
          const { rowId, type, options } = radioData;
          return (
            <React.Fragment key={rowId}>
              <Flex direction="column">
                <TextBodyMedium flexGrow={1} p="20px 12px" color="text.g1">
                  {type}
                </TextBodyMedium>
                {index !== data.length - 1 && <Divider />}
              </Flex>
              <Flex direction="column">
                <RadioSelect
                  containerProps={{ padding: '20px 0', marginTop: 0, flexGrow: 1 }}
                  options={options}
                  onChange={(optionIndex) => {
                    onChange(index, optionIndex);
                  }}
                  selectedIndex={selectedIndexList[index]}
                />
                {index !== data.length - 1 && <Divider />}
              </Flex>
            </React.Fragment>
          );
        })}
      </Grid>
    </Box>
  </Box>
);
